/**
 * ReturnsTab — returns overview with KPIs, returned-items table, by-category table, and tickets list.
 * Props: data, returnsData, goToCategory
 */
import React from 'react';
import { fmt$, fmtN, pct } from '../../../utils/formatUtils';
import ReturnTickets from './ReturnTickets';

export default function ReturnsTab({ data, returnsData, goToCategory }) {
  if (data.summary.totalReturnQty === 0) {
    return (
      <div className="sq__pane">
        <div className="sq__empty-state sq__empty-state--center">
          <div className="sq__es-icon">&#x2705;</div>
          <div className="sq__es-title">No returns this period</div>
          <div className="sq__es-sub">All clear \u2014 no items were returned in this date range.</div>
        </div>
      </div>
    );
  }

  return (
    <div className="sq__pane">
      {/* Return KPIs */}
      <div className="sq__ret-kpis">
        <div className="sq__rkpi"><div className="sq__rkpi-ico">\u21A9\uFE0F</div><div className="sq__rkpi-val">{fmtN(data.summary.totalReturnQty)}</div><div className="sq__rkpi-lbl">Items Returned</div></div>
        <div className="sq__rkpi"><div className="sq__rkpi-ico">&#x1F4B8;</div><div className="sq__rkpi-val">{fmt$(data.summary.totalReturnRevenue)}</div><div className="sq__rkpi-lbl">Return Value</div></div>
        <div className="sq__rkpi"><div className="sq__rkpi-ico">&#x1F4E6;</div><div className="sq__rkpi-val">{returnsData.length}</div><div className="sq__rkpi-lbl">Unique Items</div></div>
        <div className="sq__rkpi"><div className="sq__rkpi-ico">&#x1F4C1;</div><div className="sq__rkpi-val">{data.categories.filter(c => c.returnQty > 0).length}</div><div className="sq__rkpi-lbl">Categories Affected</div></div>
      </div>

      <div className="sq__ret-grid">
        {/* Returned items table */}
        <div className="sq__card">
          <div className="sq__card-title">Returned Items</div>
          <div className="sq__table-wrap">
            <table className="sq__table">
              <thead>
                <tr>
                  <th>Item</th><th>Category</th>
                  <th className="sq__num">Qty</th>
                  <th className="sq__num">Value</th>
                </tr>
              </thead>
              <tbody>
                {returnsData.map((item, i) => (
                  <tr key={i} className="sq__row-return">
                    <td className="sq__item-name">{item.name}</td>
                    <td className="sq__cats-cell">{item.categories.join(', ')}</td>
                    <td className="sq__num"><span className="sq__return-badge">{item.returnQty}</span></td>
                    <td className="sq__num sq__return-rev">{fmt$(item.returnRevenue)}</td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr className="sq__tfoot">
                  <td colSpan={2}>Total ({returnsData.length})</td>
                  <td className="sq__num">{fmtN(returnsData.reduce((s, i) => s + i.returnQty, 0))}</td>
                  <td className="sq__num sq__return-rev">{fmt$(returnsData.reduce((s, i) => s + i.returnRevenue, 0))}</td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>

        {/* Returns by category */}
        <div className="sq__card">
          <div className="sq__card-title">Returns by Category</div>
          <div className="sq__table-wrap">
            <table className="sq__table">
              <thead>
                <tr>
                  <th>Category</th>
                  <th className="sq__num">Returned</th>
                  <th className="sq__num">Value</th>
                  <th className="sq__num">% Revenue</th>
                </tr>
              </thead>
              <tbody>
                {data.categories.filter(c => c.returnQty > 0).map(cat => (
                  <tr key={cat.name}>
                    <td>
                      <button className="sq__link-btn" onClick={() => goToCategory(cat.name, 'returns')}>
                        {cat.name}
                      </button>
                    </td>
                    <td className="sq__num"><span className="sq__return-badge">{cat.returnQty}</span></td>
                    <td className="sq__num sq__return-rev">{fmt$(cat.returnRevenue)}</td>
                    <td className="sq__num sq__muted">{pct(parseFloat(cat.returnRevenue), parseFloat(cat.revenue))}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* Tickets with returns */}
      <div className="sq__card">
        <div className="sq__card-title">Tickets With Returns</div>
        <ReturnTickets categories={data.categories} />
      </div>
    </div>
  );
}
